import React, { FunctionComponent } from 'react';

import { useTranslation } from 'react-i18next';

import { ReplyProps } from 'reviews2/feed/review-yeti/reply/ReviewReply.types';

import 'reviews2/feed/review-yeti/reply/direct-message/ReplyDirectMessage.scss';

export const ReplyDirectMessage: FunctionComponent<ReplyProps> = ({ reply }) => {
    const { t } = useTranslation('reviews2');

    if (!reply.properties?.DM_LINK?.booleanValues?.[0]) {
        return null;
    }

    return (
        <div className="r4e-review-reply-direct-message">
            <i className="icon-envelope" />
            <span className="bold">{t('REPLY_SEND_DIRECT_MESSAGE')}</span>
        </div>
    );
};
